<template>
  <b-row>
    <b-col
      v-for="athlete in selectedAthletes"
      :key="`athlete-${athlete.id}`"
      :cols="3"
      class="px-1 pb-2"
    >
      <BasePickAthleteButton
        :id="athlete.id"
        :athlete="athlete"
        :round-id="roundId"
        @onAthletePickRemove="(params) => $emit('onAthletePickRemove', params)"
      />
    </b-col>
    <b-col
      v-for="id in Array.from(Array(8 - selectedAthletes.length).keys())"
      :key="`noathlete-${id}`"
      :cols="3"
      class="px-1 pb-2"
    >
      <BasePickAthleteButton
        :id="id + selectedAthletes.length"
        @onPlayerAdd="$emit('onPlayerAdd')"
      />
    </b-col>
  </b-row>
</template>

<script>
import BasePickAthleteButton from '@/components/Atoms/BasePickAthleteButton'

export default {
  name: 'ThePickAthletes',
  components: {
    BasePickAthleteButton,
  },
  props: {
    selectedAthletes: {
      type: [Array],
      required: true,
    },
    roundId: {
      type: [String, Number],
      required: true,
    },
  },
}
</script>
